/**
 * @param {*} req
 * @param {object} query
 * @param {object} cookies
 * @returns {Object|string}
 */
function getUserId ({ query, cookies } = {}) {
  let userId = query?.op_user_id || cookies?.op_user_id
  if (userId && userId !== 'undefined') return userId

  userId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)

    return v.toString(16)
  })

  return userId
}

module.exports = { getUserId }
